import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { getFines } from 'services';
import { fetchFinesSuccess, fetchFinesError } from 'store/actions';
import { FETCH_FINES } from 'store/actionTypes';

function* fetchFineData() {
  try {
    const userObj = yield call(getFines);
    if (!userObj.message) {
      yield put(fetchFinesSuccess(userObj));
    } else {
      yield put(fetchFinesError(userObj));
    }
  } catch (error) {
    yield put(fetchFinesError(error));
  }
}

export function* watchFines() {
  yield takeLatest(FETCH_FINES, fetchFineData);
}

export default function* rootSaga() {
  yield all([fork(watchFines)]);
}
